// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
export const SideMenuContainer = styled.div `
  --side-menu-width: 320px;
  --side-menu-spacing: 32px;
  overflow: hidden;
  transition: all 0.3s ease-in-out 0s;

  &.open {
    width: var(--side-menu-width);
    background-color: var(--color-neutral-100);
    border-right: 1px solid var(--color-neutral-200);

    .auxiliary-menu {
      opacity: 1;
      visibility: visible;
    }
  }

  &.closed {
    width: 0px;
  }

  .auxiliary-menu {
    display: flex;
    flex-direction: column;
    gap: 8px;
    opacity: 0;
    visibility: hidden;
    transition: visibility 0s linear 300ms, opacity 3ms;
    width: auto;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: var(--color-neutral-100);
    padding: 24px 0px 8px 0px;
    /* max-height: calc(100vh - 9rem); */
    max-height: calc(
      100vh -
        (
          var(--main-menu-size) + (var(--main-menu-padding) * 2) +
            var(--side-menu-spacing)
        ) - ${({ envLabel }) => (envLabel ? 'var(--env-label-height)' : '0')}
    );
    &::-webkit-scrollbar {
      width: 4px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: var(--color-neutral-200);
      margin: 16px 0px;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: var(--color-neutral-400);
      border-radius: 4px;
    }
  }

  @keyframes slide {
    0% {
      width: 0%;
    }
    100% {
      width: 100%;
    }
  }

  @media (max-width: 761px) {
    left: 0;
    height: 100%;
    position: absolute;

    .auxiliary-menu {
      width: 100%;
      height: 100%;
      opacity: 1;
      visibility: visible;
    }

    &.open {
      width: 100%;
      animation: slide 0.2s linear;
    }
    &.closed {
      width: 0%;
      animation: slide 0.2s linear reverse;
    }
  }
`;
//# sourceMappingURL=style.js.map